module.exports = __webpack_public_path__ + "static/media/photo121.3efc2938.jpg";